import React from 'react'
import { styled, Box, Typography, Stack } from '@mui/material'
import { useTranslation } from '../hooks/Localization'
import LazyImage from '../component/LazyImage'
import { blue } from '@mui/material/colors'
import HelmetPage from '../component/Page/HelmetPage'
const StyledBox = styled(Box)`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 100%;
`
const StyledBoxTextCenter = styled(Box)`
    text-align: center;
`

const NotFound: React.FC = () => {
    const t = useTranslation
    return (
        <>
            <HelmetPage isDefault={true} />
            <StyledBox>
                <Stack spacing={2}>
                    <LazyImage src="/android-chrome-192x192.png" alt={t('Webname')} sx={{ margin: 'auto' }} />
                    <StyledBoxTextCenter>
                        <Typography sx={{ textTransform: 'capitalize', color: blue[900], mt: 3, fontFamily: 'Fredericka the Great' }} variant="h4">
                            {t('Oops, page not found.')}
                        </Typography>
                    </StyledBoxTextCenter>
                </Stack>
            </StyledBox>
        </>
    )
}
export default NotFound
